const Footer = () => (
    <footer className="footer-wrapper">
        <p className="footer-wrapper__link">Made by <a href="https://martalewan.com/">Marta Lewan</a></p>
        <p className="footer-wrapper__link">2022</p>
    </footer>
);

export default Footer;